import { render, staticRenderFns } from "./ManualQuestionnaire.vue?vue&type=template&id=ab0b39c4&scoped=true&"
import script from "./ManualQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./ManualQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./ManualQuestionnaire.vue?vue&type=style&index=0&id=ab0b39c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0b39c4",
  null
  
)

export default component.exports